/**
 * @file Purchase Album Checkout Success view.
 */

import React from 'react';

import PurchaseAlbumCheckoutSuccessContainer from '../../containers/purchase/PurchaseAlbumCheckoutSuccessContainer';

const PurchaseAlbumCheckoutSuccessView = () => (
  <PurchaseAlbumCheckoutSuccessContainer />
);

export default PurchaseAlbumCheckoutSuccessView;
